import { render, staticRenderFns } from "./configure-receipt-fields.vue?vue&type=template&id=7b6ac9c7&scoped=true"
import script from "./configure-receipt-fields.vue?vue&type=script&lang=js"
export * from "./configure-receipt-fields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b6ac9c7",
  null
  
)

export default component.exports